// Persist the last successful claim/buy per birthday year, so the Thanks page can
// recover it after a reload or a direct visit without a #hash. We keep both the
// transaction id (shown on the page) and the base64 group id (used for the Allo
// group link). Keyed by year => one slot per year (e.g. lastTx:2026).

const KEY_PREFIX = 'lastTx:';

const keyFor = (year) => `${KEY_PREFIX}${year}`;

// record: { txId, groupId }
export function saveLastTx(year, record) {
  if (!year || !record || (!record.txId && !record.groupId)) return;
  try {
    window.localStorage.setItem(keyFor(year), JSON.stringify(record));
  } catch (e) {
    // Private mode / storage disabled — non-fatal.
    console.warn('saveLastTx failed', e);
  }
}

export function loadLastTx(year) {
  if (!year) return null;
  try {
    const raw = window.localStorage.getItem(keyFor(year));
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      // Legacy entries were a bare transaction-id string.
      return typeof parsed === 'string' ? { txId: parsed } : parsed;
    } catch {
      return { txId: raw };
    }
  } catch (e) {
    console.warn('loadLastTx failed', e);
    return null;
  }
}
